<template>
    <structure>
        <section class="load" v-if="load"></section>
        <section class="users" v-if="!load">
            <div class="title">
                <div>
                    <h1>Usuários Cadastrados</h1>
                    <p>Existe {{total}} usuários encontrados</p>
                </div>
            </div>
            <div class="page-control">
                <div>
                    <div class="tabs">
                        <ul>
                            <li>
                                <router-link to="/usuarios/todos">Todos</router-link>
                            </li>
                            <li v-for="role in roles" :key="role.id">
                                <router-link :to="'/usuarios/'+role.slug">{{role.name}} </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="isPermission('users_add')">
                    <button type="button" @click="modal('modal','add-user')">Adicionar <i class="fal fa-plus"></i></button>
                </div>
            </div>
            
            <div class="list" v-if="total">
                <div class="item" v-for="(user, index) in users" :key="user.id" :class="user.metas.block ? 'block':''">
                    <div class="box">
                        <ui-menu-action class="float" v-if="isPermissions('users_edit,users_block')">
                            <li v-if="isPermission('users_edit')">
                                <button type="button" @click.prevent="editUser(user)">Editar</button>
                            </li>
                            <li v-if="isPermission('users_block')" >
                                <button type="button" @click.prevent="block(user.id, index)">{{ user.metas.block ? 'Desbloquear' : 'Bloquear'}}</button>
                            </li>
                        </ui-menu-action>
                        <div class="avatar">
                            <img :src="user.metas.avatar" :alt="user.metas.first_name">
                        </div>
                        <div class="infos" v-if="user">
                            <div class="name">{{user.metas.first_name}}</div>
                            <div class="role">{{user.role_name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <ui-no-result v-if="!total" text="Nenhuma usuário encontrado" />

            <div class="pagination" v-if="!load">
                <button type="button" :class="reloadIndicator" @click="pagination()" v-if="hiddenPagination">Carregar mais</button>
            </div>

        </section>

        <ui-modal-add />
        <ui-modal-edit />
        
        <ui-modal id="remove-user" title="Confirmar Exclusão" title-text="Tem certeza que deseja excluir esse usuário?" size="xs">
            <div class="control">
                <button type="button" class="btn-cancel" @click="modal('modal-close', 'remove-user')">Não</button>
                <button type="button" class="btn-confirm">Sim</button>
            </div>
        </ui-modal>

    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import { uiMenuAction, uiModal, uiNoResult,  } from '@/components'
    import { roles, user } from '@/services'
    import uiModalAdd from './add'
    import uiModalEdit from './edit'
    import permissions from '@/mixins/permissions'
    export default {
        name: 'users',
        components: { structure, uiMenuAction, uiModal, uiNoResult, uiModalAdd, uiModalEdit },
        mixins: [ permissions ],
        data() {
            return {
                statusModal: false,
                roles: [],
                users: [],
                pages: 0,
                total: 0,
                role: null,
                params: '?page=1',
                page: 1,
                load: true,
                hiddenPagination: true,
                loadSave: false,
                reload: false,
                message: '',
                form: {
                    first_name: '',
                    last_name: ''
                }
            }
        },
        computed: {
            indicatorSave(){
                return this.loadSave ? 'load' : ''
            },
            ispagination(){
                return this.page < this.pages ? true : false
            },
            reloadIndicator(){
                return this.reload ? 'loading' : ''
            }
        },
        watch: {
            '$route.params.role'(role){
                this.getParams(role)
                this.page = 1
                this.users = []
                this.hiddenPagination = true
                this.list()
            },
            page(){
                this.hiddenPagination = true
                this.getParams(this.$route.params.role)
                this.list()
            }
        },
        methods: {
            modal(action, id){
                this.$root.$emit(action, id);
            },
            getRoles(){
                roles.read().then( response => {
                    this.roles = response.data
                    this.load = false
                })
            },
            list(){
                this.reload = true
                user.list(this.params).then( response => {
                    this.pages = response.headers['x-wp-totalpages']
                    this.total = response.headers['x-wp-total'] * 1
                    this.users = [...this.users, ...response.data]
                    this.getRoles()
                    this.reload = false
                    

                    if(this.page < this.pages){
                        this.hiddenPagination = true
                    }else{
                        this.hiddenPagination = false
                    }
                    
                })
            },

            block(user_id, index){
                user.block(user_id).then( response => {
                    this.users[index].metas.block = response.data.row.block
                })
            },
            
            getParams(role){
                this.params = role !== 'todos' ? this.params = `?roles=${role}&page=${this.page}` : this.params = `?page=${this.page}`
            },
            editUser(user){
                let data = {
                    id: user.id,
                    first_name: user.metas.first_name,
                    last_name: user.metas.last_name,
                    email: user.metas.email,
                    role: user.role
                }
                this.$root.$emit('edit-user', data);
            },
            pagination(){
                if(this.page >= this.pages) return false
                this.page = this.page + 1
            },
            
        },
        created(){
            this.getRoles()
            this.role = this.$route.params.role
            this.getParams(this.role)
            this.list()
            
            this.$root.$on("reloat-users", () => {
                this.modal('modal-close', 'add-user')
                this.modal('modal-close', 'edit-user')
                setTimeout( () =>{
                    this.users = []
                    this.list()
                }, 500)

            })
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
